/**
 * Worker advantages — chip catalog cho profile + post requirement matching.
 * Trong Posting requirements: dùng các flag dedicated (reqMotorbikeRequired,
 * reqExcludeVisibleTattoo) cho hard filter. Còn list chip này hiển thị
 * trên profile + có thể overlap khi compute soft match.
 */
export const ADVANTAGES_CATALOG = [
  "HAS_MOTORBIKE",
  "HAS_BIKE",
  "HAS_LAPTOP",
  "NO_VISIBLE_TATTOO",
  "STRONG_HEALTH",
  "CAN_LIFT_HEAVY",
  "STAND_LONG_HOURS",
  "NIGHT_OWL",
  "EARLY_BIRD",
  "FOOD_SAFETY_CERT",
  "VACCINATED_FNB",
  "FIRST_AID_CERT",
  "DRIVING_LICENSE_B2",
  "STUDENT_ID_VALID",
] as const;

export type Advantage = (typeof ADVANTAGES_CATALOG)[number];

export const ADVANTAGE_LABEL_VI: Record<Advantage, string> = {
  HAS_MOTORBIKE: "Có xe máy",
  HAS_BIKE: "Có xe đạp",
  HAS_LAPTOP: "Có laptop",
  NO_VISIBLE_TATTOO: "Không hình xăm visible",
  STRONG_HEALTH: "Sức khỏe tốt",
  CAN_LIFT_HEAVY: "Bê được vật nặng",
  STAND_LONG_HOURS: "Đứng lâu được",
  NIGHT_OWL: "Quen làm khuya",
  EARLY_BIRD: "Quen dậy sớm",
  FOOD_SAFETY_CERT: "Có giấy ATTP",
  VACCINATED_FNB: "Đã tiêm vaccine F&B",
  FIRST_AID_CERT: "Có chứng chỉ sơ cứu",
  DRIVING_LICENSE_B2: "Bằng lái B2",
  STUDENT_ID_VALID: "Đang là sinh viên (thẻ còn hạn)",
};
